<script setup lang="ts">
defineProps<{ is_external: boolean | undefined | null }>()
const { t } = useI18n()
</script>

<template>
  <Badge v-if="is_external" color="yellow" class="font-bold">
    {{ t("ext") }}
  </Badge>
</template>

<i18n lang="yaml">
en:
  ext: Ext
fr-FR:
  ext: Ext
</i18n>
